<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md6>
        <jti-expansion-panel panelName="Device Details">
          <v-container fluid class="py-0">
            <v-form v-model="valid" ref="form" lazy-validation>
              <!-- <v-text-field
                v-if="!showName"
                v-model="data.name"
                label="Name"
                :readonly="readonly"
                required
                :rules="rules"
              ></v-text-field>-->
              <v-text-field
                v-model="data.device_serial"
                label="Device Serial"
                :readonly="readonly"
                required
                :rules="rules"
              ></v-text-field>
              <v-text-field
                v-model="data.model"
                label="Model"
                :readonly="readonly"
                required
                :rules="rules"
              ></v-text-field>
              <v-textarea outline v-model="data.remarks" :readonly="readonly" label="Remarks"></v-textarea>
            </v-form>
             <v-switch
               color="#00C853"
               v-model="computedData.device_status" 
               :readonly="readonlyDevice"
               :label="computedData.device_status_label"
               @change="deviceStatusChange"
            ></v-switch>
          </v-container>
        </jti-expansion-panel>
      </v-flex>
      <v-flex md6 v-if="showSoftwareSerial">
        <jti-expansion-panel panelName="Software Serial Selection">
          <v-container fluid class="py-0">
            <v-form v-model="valid" ref="form" lazy-validation>
              <v-select
                v-model="data.software_serial_id"
                :items="softwareSerials"
                label="Software Serial"
                :clearable="!readonlySoftwareSerial"
                :readonly="readonlySoftwareSerial"
              ></v-select>
            </v-form>
          </v-container>
        </jti-expansion-panel>
      </v-flex>
      <v-flex md6 v-if="showVehicle && !data.spare_status">
        <jti-expansion-panel panelName="Vehicle Selection">
          <v-container fluid class="py-0">
            <v-form v-model="valid" ref="form" lazy-validation>
              <v-select
                v-model="data.vehicle_id"
                :items="vehicles"
                label="Vehicle"
                :clearable="!readonlyVehicle"
                :readonly="readonlyVehicle"
              ></v-select>
            </v-form>
          </v-container>
        </jti-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
    readonly: Boolean,
    projects: Array,
    companies: Array,
    subcompanies: Array,
    showSoftwareSerial: Boolean,
    showVehicle: Boolean,
    readonlySoftwareSerial: Boolean,
    readonlyVehicle: Boolean,
    softwareSerials: Array,
    vehicles: Array,
    readonlyDevice: Boolean
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        name: this.data.name,
        device_serial: this.data.device_serial,
        model: this.data.model,
        remarks: this.data.remarks,
        software_serial_id: this.data.software_serial_id,
        vehicle_id: this.data.vehicle_id,
        device_status: this.data.device_status === '0x00FE' ? true : false,
        device_status_label: this.status_label !== null ? this.status_label : this.data.device_status === '0x00FE' ? 'Device Enabled' : 'Device Deactivated',
      };
    }
  },
  data() {
    return {
      valid: true,
      rules: [v => !!v || "This field is required"],
      status_label: null
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    },
    deviceStatusChange() {
      this.computedData.device_status == true ? this.status_label = 'Device Enabled' : this.status_label = 'Device Deactivated';
    }
  }
};
</script>

<style>
</style>
